export default __webpack_public_path__ + "static/media/realpeople.cd85d2d8.jpg";